const message = {
  msg_1: '联系我们',
  msg_2: '新闻动态',
  msg_3: '加入我们',
  msg_4: '关于汇智',
  msg_5: '技术',
}

export default message